import React from "react"
import { Link } from "gatsby"
import {
    AiFillLinkedin,
    AiFillGithub,
    AiFillTwitterSquare
} from 'react-icons/ai'
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

// import selfie from "../images/selfie.jpg"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/home.css"


const IndexPage = () => {
    const query = useStaticQuery(
        graphql`
            query {
                image: file(relativePath: { eq: "dave.png" }) {
                    childImageSharp {
                        fluid(maxWidth: 1000, quality: 100) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        `
    );

    return (
        <Layout>
            <SEO title="Home" />
            <div className="home-page-container">
                <div
                    className="nav-spacing"
                    style={{
                        marginBottom: `2rem`,
                        backgroundImage: 'linear-gradient(#f7f8fa, #D6D9DE)',
                        width: `100%`
                    }}
                >
                    <div className="selfie-container">
                        <Img fluid={query.image.childImageSharp.fluid} />
                    </div>
                </div>
                <div className="home-page-content">
                    <section className="home-page-content-wrapper">
                        <div className="home-page-interests">
                            <p>Hi, my name is David Macharia Mwangi a Software Developer living in Nairobi, Kenya. I have three years of coding experience focusing on full-stack development. I also possess a growing interest in blockchain and web3</p>
                        </div>
                        <div className="home-page-details">
                            <p>I'm a full-stack Software Developer with a built interest in utilizing code to puzzle out problems. I enjoy taking up new challenges, engaging in innovative hackathons and mentorship programs, and contributing to the open-source community. In my spare time, catch me cheering on my favorite soccer club.</p>
                            <p>Check out my <Link className="mark" to="/projects">projects</Link> and <Link className="mark" to="cv">cv</Link> to get to know me a bit better.</p>
                            <p>Need some help on your software project? Shoot me an <Link className="mark" to="/contact"> email</Link>! You can also find me on my socials:<br />
                                <small className="footer-links">
                                    <a href="https://www.linkedin.com/in/david-mwangi-78622b174" target="_blank">
                                        <AiFillLinkedin className="footer-sm-links" />
                                    </a>
                                    <a href="https://github.com/dave-mash" target="_blank">
                                        <AiFillGithub className="footer-sm-links" />
                                    </a>
                                    <a href="https://twitter.com/theetechpriest_" target="_blank">
                                        <AiFillTwitterSquare className="footer-sm-links" />
                                    </a>
                                    <br /></small> Let's have a chat. Carpe Diem!</p>
                        </div>
                    </section>
                </div>
            </div>
        </Layout>
    )
}

export default IndexPage